module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-907f29efd9280e83f66f0e75ba174bbb.png";